/* global google */
import React from 'react';
import styles from './styles.scss';

class GoogleTranslate extends React.Component {
  state = {
    isLoaded: false,
  };

  componentDidMount() {
    this.checkForScript();
  }

  checkForScript = () => {
    if (google && google.translate && google.translate.TranslateElement) {
      this.setState({ isLoaded: true });
    } else {
      setTimeout(this.checkForScript, 100);
    }
  }

  registerRootElement = (ref) => {
    if (!ref) {
      return;
    }

    google.translate.TranslateElement(
      {
        pageLanguage: 'en',
        includedLanguages: 'en,zh-CN,ko,fa,fr,es,vi',
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
      },
      'google-translate-widget',
    );
  };

  render() {
    const { isLoaded } = this.state;

    if (!isLoaded) {
      return null;
    }

    return (
      <div
        id="google-translate-widget"
        className={styles.googleTranslate}
        ref={this.registerRootElement}
      />
    );
  }
}

export default GoogleTranslate;
